import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './HeroBanner.css';

const slides = [
  { image: require('../../Assets/Hero.png'), title: "Safari ya Maarifa: Learn, Discover & Grow.", subTitle: "Your syllabus, your pace, your mastery." },
  { image: require('../../Assets/Hero2.jpg'), title: "Fikia Malengo Yako: Learn Today, Lead Tomorrow", subTitle: "Where curiosity meets expertise." },
  { image: require('../../Assets/Hero3.jpg'), title: "Jifunze Nasi: Your Journey to Excellence", subTitle: "Your roadmap to top grades." }
];

function HeroBanner({ isLoggedIn }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const handleGetStartedClick = () => {
    navigate("/signUp");
  };

  return (
    <div className='hero-container' style={{ backgroundImage: `url(${slides[currentSlide].image})` }}>
      <div className='hero-overlay'>
        <div className='hero-placing'>
          <span className='header-title'>{slides[currentSlide].title}</span>
          <span className='sub-header-text'>{slides[currentSlide].subTitle}</span>
        </div>
        {!isLoggedIn && (
          <div className='hero-call-to-action'>
            <span className="start-user" onClick={handleGetStartedClick}>Get Started</span>
          </div>
        )}
      </div>
      {/* Slide Navigation Dots */}
      <div className="slide-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
} 

export default HeroBanner;
